import { CREATE_USER_LINK_WITH_HOSPITAL } from '../../store/modules/linkUser/linkUser.actions';

export default {
  onValidated(isValid) {
    this.hasErrors = !isValid;
  },
  createUserAndLinkWithHospital() {
    this.$store.dispatch(CREATE_USER_LINK_WITH_HOSPITAL, {
      hospitalId: this.$route.params.hospitalId,
      role: this.$store.state.linkUser.selectedRole,
      email: this.$data.formModel.email,
      username: this.$data.formModel.username,
      firstName: this.$data.formModel.firstName,
      lastName: this.$data.formModel.lastName,
      sendWelcomeEmail: this.$data.formModel.sendWelcomeEmail,
    });
  },
};



// WEBPACK FOOTER //
// ./src/components/OrganizationAdminAddForm/organizationAdminAddForm.methods.js